import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import FormikUncontrolledRadioGroup from '@minecraft.formik-uncontrolled-radio-group';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';

type Props = FilterData;

const ProfileStatus: FC<Props> = ({ name, label }) => {
  const { values } = useFormikContext();
  const { isSearching, getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory();

  return (
    <>
      {isSearching && <Label>{label}</Label>}
      <FormikUncontrolledRadioGroup
        saveAsOption
        enableReinitializeDefaultValue
        name={name}
        defaultValue={values[name]}
        options={getMatchedSearchOptions(name)}
        data-qa-id="profileStatus"
      />
    </>
  );
};

export default ProfileStatus;
